/** U+2733 / U+2197 — iOS les affiche souvent en emoji ; remplacés par pictos SVG CSS. */
const JARDINS_STAR_CHAR = '\u2733';
const JARDINS_ARROW_NE_CHAR = '\u2197';

const JARDINS_STAR_RE = /\u2733(?:\uFE0F|\uFE0E)?/g;
const JARDINS_ARROW_NE_RE = /\u2197(?:\uFE0F|\uFE0E)?/g;
const JARDINS_ARROW_NE_SINGLE = /\u2197(?:\uFE0F|\uFE0E)?/;
const JARDINS_ARROW_NE_SPAN_RE =
  /<span[^>]*class="[^"]*jardins-arrow-ne[^"]*"[^>]*>\s*<\/span>/gi;

export function containsJardinsDecor(text) {
  if (typeof text !== 'string' || !text) return false;
  return text.includes(JARDINS_STAR_CHAR) || text.includes(JARDINS_ARROW_NE_CHAR);
}

/** @deprecated alias */
export function htmlContainsJardinsStar(html) {
  return containsJardinsDecor(html);
}

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function replaceJardinsDecorInHtml(html) {
  if (!containsJardinsDecor(html)) return html;
  return html
    .replace(
      JARDINS_STAR_RE,
      '<span class="jardins-picto" aria-hidden="true"></span>',
    )
    .replace(
      JARDINS_ARROW_NE_RE,
      '<span class="jardins-arrow-ne" aria-hidden="true"></span>',
    );
}

/** Alias historique (✳ + ↗). */
export function replaceJardinsPictoInHtml(html) {
  return replaceJardinsDecorInHtml(html);
}

/** Libellés boutons (texte brut, échappé puis pictos). */
export function replaceJardinsDecorInPlainText(text) {
  if (typeof text !== 'string' || !text) return text;
  const cleaned = String(text)
    .replace(JARDINS_ARROW_NE_SPAN_RE, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!containsJardinsDecor(cleaned)) return escapeHtml(cleaned);
  return replaceJardinsDecorInHtml(escapeHtml(cleaned));
}

/** CTA menu compact : une seule flèche, alignée à droite via flex CSS. */
export function jardinsCtaLabelHtml(label, fallback = 'Réserver') {
  const raw = String(label || fallback).trim();
  const withoutPicto = raw
    .replace(JARDINS_ARROW_NE_SPAN_RE, '')
    .replace(JARDINS_ARROW_NE_SINGLE, '')
    .replace(/\s+/g, ' ')
    .trim();
  const withArrow = withoutPicto
    ? `${withoutPicto} ${JARDINS_ARROW_NE_CHAR}`
    : JARDINS_ARROW_NE_CHAR;
  return replaceJardinsDecorInPlainText(withArrow);
}

/** Retire ↗ du libellé (texte brut). */
export function stripJardinsArrowFromPlainText(text) {
  return String(text || '')
    .replace(JARDINS_ARROW_NE_SPAN_RE, '')
    .replace(JARDINS_ARROW_NE_SINGLE, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function plainTextHasJardinsArrow(text) {
  if (typeof text !== 'string' || !text) return false;
  return text.includes(JARDINS_ARROW_NE_CHAR) || /jardins-arrow-ne/i.test(text);
}

export function shouldUseJardinsPicto({ kitStyle, site }) {
  if (String(kitStyle || '').startsWith('jardins-')) return true;
  return (site?.sections || []).some((sec) => sec.designKit === 'jardins');
}
